import { useReducer } from 'react';
import { FormField, TextInput } from 'grommet';
import { HelpWith } from '@components/basicComponents';
import { HelpWithType } from '@customTypes/enums';
import type { FormFieldsProps } from '@customTypes/types';
import type { DeveloperPortalSupportFormFieldsState } from '@customTypes/stateTypes';
import {
  apiIssuesOptions,
  developerPortalIssuesOptions,
  supportIssueDetailsOptions,
  partnerApiIssuesOptions
} from './DeveloperPortalSupportFormOptions';

export const DeveloperPortalSupportFormFields = (props: FormFieldsProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: DeveloperPortalSupportFormFieldsState, newState: Partial<DeveloperPortalSupportFormFieldsState>) => ({
      ...prev,
      ...newState,
    }),
    {
      helpWith: '',
      helpWithSecondary: '',
      secondDropdownOptions: null,
      showApiDescription: false,
    }
  );

  const helpWithChange = (option: string): void => {
    if (option === state.helpWith) {
      return;
    }

    switch (option) {
      case supportIssueDetailsOptions.api:
        updateState({ helpWith: option, secondDropdownOptions: apiIssuesOptions, helpWithSecondary: '', showApiDescription: false });
        props.onDetailsChange({ showDetails: false, numFiles: 0 });
        break;
      case supportIssueDetailsOptions.developerPortal:
        updateState({ helpWith: option, secondDropdownOptions: developerPortalIssuesOptions, helpWithSecondary: '', showApiDescription: false });
        props.onDetailsChange({ showDetails: false, numFiles: 0 });
        break;
      case supportIssueDetailsOptions.partnerApi:
        updateState({ helpWith: option, secondDropdownOptions: partnerApiIssuesOptions, helpWithSecondary: Object.values(partnerApiIssuesOptions)[0], showApiDescription: true });
        props.onDetailsChange({ showDetails: true, numFiles: 0 });
        break;
      case supportIssueDetailsOptions.other:
        updateState({ helpWith: option, secondDropdownOptions: null, helpWithSecondary: '', showApiDescription: false });
        props.onDetailsChange({ showDetails: true, numFiles: 0 });
        break;
      default:
        updateState({ helpWith: option, secondDropdownOptions: null, helpWithSecondary: '', showApiDescription: false });
        props.onDetailsChange({ showDetails: false, numFiles: 0 });
        break
    }
  };

  const helpWithSecondaryChange = (option: string): void => {
    if (option === state.helpWithSecondary) {
      return;
    }

    if (state.helpWith === supportIssueDetailsOptions.api) {
      updateState({ showApiDescription: true });
    }

    updateState({ helpWithSecondary: option });
    props.onDetailsChange({ showDetails: true });
  };

  const clearState = (): void => {
    updateState({ helpWith: '', helpWithSecondary: '', secondDropdownOptions: null, showApiDescription: false });
  };

  props.onReset && props.onReset(clearState);

  return (
    <>
      <HelpWith
        selectType={!props.isConsolidated ? HelpWithType.First : HelpWithType.Second}
        options={Object.values(supportIssueDetailsOptions)}
        value={state.helpWith}
        onChange={helpWithChange}
      />

      {state.secondDropdownOptions &&
        <HelpWith
          selectType={!props.isConsolidated ? HelpWithType.Second : HelpWithType.Third}
          options={Object.values(state.secondDropdownOptions)}
          value={state.helpWithSecondary}
          onChange={helpWithSecondaryChange}
        />
      }

      {state.showApiDescription &&
        <FormField name="apiDescription" htmlFor="api-description" label="API name" required>
          <TextInput id="api-description" name="apiDescription" placeholder="API name" />
        </FormField>
      }
    </>
  )
};
